import { AssetPack } from '../../../../types/AssetPack';
import { app } from '../App';

export default abstract class BaseScene extends Phaser.Scene {
  public static transitionEvents = {
    TransitionCovering: 'transitionCovering',
    TransitionCovered: 'transitionCovered',
    TransitionUncovering: 'transitionUncovering',
    TransitionUncovered: 'transitionUncovered'
  } as const

  private assetPack: AssetPack | undefined;

  constructor(x: string) {
    super({ key: x });
  }

  public init(data: object) {
    // this.assetPack = assetPack;
    console.log(`${this.scene.key} Data!`, data);
  }

  public preload() {
    console.log(`Preload ${this.scene.key}!`);
    // console.log(this.cache);
    // console.log(this.textures);
  }

  public postload() {
    console.log(`Postload ${this.scene.key}!`);
    // console.log(this.cache);
    // console.log(this.textures);

    // Compare all manifests.
    // Unload missing items.
  }

  public create() { }

  /**
   * Creates a third scene to cover the transition between two scenes while waiting for the new scene to do any preload.
   *
   * @param config
   * @returns
   */
  public startTransition(config: Phaser.Types.Scenes.SceneTransitionConfig): boolean {
    let targetScene = this.scene.get(config.data.transitionData.nextScene);
    let transitionScene = this.scene.get(config.target);

    if (!targetScene || !transitionScene) return false;

    transitionScene.events.once(BaseScene.transitionEvents.TransitionCovered, () => {
      if (targetScene.sys.isSleeping()) targetScene.sys.wake();
      else this.scene.manager.start(config.data.transitionData.nextScene);

      this.scene.manager.stop(this.scene.key);
    });

    if (transitionScene.sys.isSleeping()) transitionScene.sys.wake();
    else this.scene.manager.start(config.target, config.data);

    return true;
  }

  protected completeTransition() {

  }

  public shutdown() {
    console.log(`Shutting Down Scene ${this.scene.key}!`);
  }

  public destroy() {
    console.log(`Destroying Scene ${this.scene.key}!`);
  }

  protected finish() {}

  // abstract unload: (assetPack: AssetPack) => void;
}
